// 接入小程序预请求的prod_key
export const PRE_INIT_LIST = ['ut-dunion-wyc']

// 关闭sw
export const DISABLE_SW_LIST = ['ut-dunion-car']
